import React, { Fragment } from "react";

export default function GroupLoadingRow({ rows, ...remainder }) {
    const items = [];
    for (let i = 0; i < rows; i++) {
        items.push(
            <tr className="animate-pulse" key={"userloadingrow".concat(i)}>
                <td className="px-6 py-4 whitespace-nowrap">
                    <div className="flex items-center">
                        <div className="flex-shrink-0 h-10 w-10">
                            <div className="rounded-full bg-gray-200 h-10 w-10">
                                &nbsp;
                            </div>
                        </div>
                        <div className="ml-4 w-full">
                            <div className="rounded w-full bg-gray-200 h-4"></div>{" "}
                            <div className="rounded w-2/3 mt-1 bg-gray-200 h-4"></div>{" "}
                        </div>
                    </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                    <div className="w-full">
                        <div className="rounded w-full bg-gray-200 h-4"></div>{" "}
                        <div className="rounded w-2/3 mt-1 bg-gray-200 h-4"></div>{" "}
                    </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                    <div className="w-full">
                        <div className="rounded w-1/2 bg-gray-200 h-4"></div>
                    </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    <div className="w-full">
                        <div className="rounded w-1/2 bg-gray-200 h-4"></div>
                    </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                    <span className="text-gray-200">Edit</span>
                </td>
            </tr>
        );
    }

    return <Fragment>{items}</Fragment>;
}
